import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess, setError } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'REPORTS_CONFORMIDADE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'REPORTS_CONFORMIDADE_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro = {}) {
    return {
        type: 'REPORTS_CONFORMIDADE_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function getLista(filtro, carregando) {
	return (dispatch, getState) => {
		dispatch(setAguardando(carregando));

    	axios.get(`${consts.API_DATALAKE_URL}/reports/conformidade?padrao=true
			&tipo_periodo=${filtro.tipo_periodo}
			${filtro.data_inicial ? `&data_inicial=${DateFormat.formatarDataTelaParaSql(filtro.data_inicial)}` : ''}
			${filtro.data_final ? `&data_final=${DateFormat.formatarDataTelaParaSql(filtro.data_final)}` : ''}
		`).then(resp => {
			dispatch({
		        type: 'REPORTS_CONFORMIDADE_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaFronteiras() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'REPORTS_CONFORMIDADE_FRONTEIRA_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

    	axios.get(`${consts.API_DATALAKE_URL}/reports/fronteiras`)
		.then(resp => {
			dispatch({
		        type: 'REPORTS_CONFORMIDADE_FRONTEIRA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaNegociadores() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'REPORTS_CONFORMIDADE_NEGOCIADOR_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

    	axios.get(`${consts.API_DATALAKE_URL}/reports/negociadores`)
		.then(resp => {
			dispatch({
		        type: 'REPORTS_CONFORMIDADE_NEGOCIADOR_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaOperacoes() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'REPORTS_CONFORMIDADE_OPERACAO_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

    	axios.get(`${consts.API_DATALAKE_URL}/operacao/listarSelect`)
		.then(resp => {
			dispatch({
		        type: 'REPORTS_CONFORMIDADE_OPERACAO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}
